// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beer-desktop-container{
    height: 30vw;
    display: none;
}
.beer-title-container{
    display: flex;
    height: 15vw;
    justify-content: end;
    align-items: end; 
    background-color: #fff7e4;
    padding-top: 10%;
}
.l-beer-title{
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: end;
    padding-left: 7%;
}
.r-beer-title{
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: end;
    align-items: end;
    padding-right: 7%;
}
.beer-image{
    height: 20vw;
    width: auto;
    margin-bottom: 3.5%;
}
.brewery-logo{
    height: 72%;
    width: auto;
    margin-right: 5%;
    margin-bottom: 4.5%;
}
.beer-title{
  margin-right: 0%;
  font-size: 7.5vw;
  line-height: 8.25vw;;
  font-weight: 700;
  font-style: normal;
  letter-spacing: .05vw;
  color: rgb(0, 0, 0);
  margin: 0 0 1.25% 0;
}
.beer-year{
  font-size: 4.5vw;
  line-height: 5.25vw;
  font-weight: 400;
  font-style: normal;
  letter-spacing: .05vw;
  color: rgb(0, 0, 0);
  margin: 0;
  padding-left: .75%;
}
.beer-content-div{ 
  z-index: 2;
  width: 100vw;
}
.beer-top-right{
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 13% 7% 5% 7%;
    background-color: #fff7e4;
}
.my-profile-header-beer{
    font-size: 5.5vw;
    line-height: 6.5vw;
    font-weight: 700;
    letter-spacing: .05vw;
    color: rgb(0, 0, 0);
    margin: 0 0 2% 0;
}
.user-profile-beer{
    font-size: 4.25vw;
    line-height: 6vw;
    font-weight: 400;
    letter-spacing: .05vw;
    color: rgb(0, 0, 0);
    margin: 0 0 3.25% 0;
}
.beer-flavors-header{
    font-size: 5vw;
    line-height: 5.5vw;
    font-weight: 700;
    letter-spacing: .05vw;
    color: rgb(0, 0, 0);
    margin: 11.5% 0 5.5% 0;
}
.beer-flav-img-container{
    height: 17vw;
    width: 17vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10vw;
    margin: 0 auto 9% auto;
}
.beer-flavor-title{
    font-size: 3.5vw;
    line-height: 4.5vw;
    font-weight: 400;
    letter-spacing: .05vw;
    color: rgb(0, 0, 0);
    text-align: center;
    margin-top: 0%;
}
.beer-flavor-box{
    width: 33%;
    justify-content: center;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.beer-acid-sweetness-columns{
    display: flex;
    justify-content: space-between;
    padding: 6% 7.25% 8% 7.25%;
    background-color: #fff7e4;
}
.beer-acidity-bar{
    display: flex;
    align-items: center;
    height: 4vw;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;  
}
.beer-sweetness-bar{
    display: flex;
    align-items: center;
    height: 4vw;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;   
}
.beer-flavors-container{
    height: auto;
    display: flex;
    padding-left: 0%;
    justify-content: left;
}
.beer-acidity-header{
    margin: 0;
    padding-bottom: 3%;
    font-size: 4.25vw;
    margin-bottom: 2%;
    color: black;
    font-weight: 600;
    font-style: normal;
    letter-spacing: .05vw;
}
.beer-low-lable, .beer-high-lable{
    font-size: 3.25vw;
    line-height: 4.75vw;
    font-weight: 500;
    letter-spacing: .05vw;
    color: rgb(0, 0, 0);
    margin: 10% 3% 0 3%;
}
.triangle-section{
    padding: 2% 7% 8% 7%;
    background-color: #fff7e4;
}
.triangle-container{
    width: 53vw;
    height: 53vw;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.bitter-text{
    font-size: 3.5vw;
    font-weight: 400;
    color: black;
    text-align: center;
    margin: 0% 0 2% 0 ;
    letter-spacing: .05vw;

}
.sweet-text{
    font-size: 3.5vw;
    font-weight: 400;
    color: black;
    margin: 0;
    position: absolute;
    bottom: 3.75%;
    left: 6%;
    letter-spacing: .07vw;
}
.dry-text{
    font-size: 3.5vw;
    font-weight: 400;
    color: black;
    margin: 0;
    position: absolute;
    bottom: 3.75%;
    right: 8%;
    letter-spacing: .07vw;
}
.triangle-img{
    width: 93%;
    left: 2.5%;
    top: 10%;
    height: auto;
    margin: 0 0 0 0;
    position: absolute;
    z-index: 0;
}

.bottom-section-container{
    background-color: #fdf9f1;
    padding: 3% 7% 5% 7%;
}
.beer-profile-header{
    font-size: 5.5vw;
    line-height: 6.5vw;
    font-weight: 700;
    letter-spacing: .05vw;
    color: rgb(0, 0, 0);
    margin: 5% 0 2% 0;
}
.beer-description{
    margin-bottom: 10%;
}
.beer-acid-sweetness-columns-bottom{
    display: flex;
    justify-content: space-between;
    padding: 3% 7.25% 10% 7.25%;
    background-color: transparent;
    background-color: #fdf9f1;
}
.l-acid-col-beer{
    display: flex;
    flex-direction: column;
    align-items: left;
    width: 35%;
}
.r-acid-col-beer{
    display: flex;
    flex-direction: column;
    justify-content: right;
    align-items: right;
    width: 70%;
}
.lively-bubbles{
    padding: 0;
    margin: 5% 0% 0% 0%;
    text-align: right;
}
.bottom-triangle-sect{
    background-color: #fdf9f1;
    padding: 3% 7% 7% 7%;
}
.beer-qr-code-section{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3% 0 4% 0%;
  width: 100%;
  background-color: #fdf9f1;
}



@media only screen and (min-width: 700px) and (min-height: 1000px){
    .beer-desktop-container{
        display: none;
    }
    .beer-title-container{
        display: flex;
        height: 12vw;
        justify-content: end;
        align-items: end; 
        background-color: #fff7e4;
        padding-top: 10%;
    }
    .l-beer-title{
        width: 70%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: end;
        padding-left: 7%;
    }
    .r-beer-title{
        display: flex;
        width: 50%;
        height: 100%;
        justify-content: end;
        align-items: end;
        padding-right: 7%;
    }
    .beer-image{
        height: 17vw;
        width: auto;
        margin-bottom: 4%;
    }
    .brewery-logo{
        height: 78%;
        width: auto;
        margin-right: 7%;
        margin-bottom: 4.5%;
    }
    .beer-title{
        margin-right: 0%;
        font-size: 5.75vw;
        line-height: 6.5vw;;
        font-weight: 700;
        font-style: normal;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        margin: 0 0 1.5% 0;
    }
    .beer-year{
        font-size: 4vw;
        line-height: 5vw;
        font-weight: 400;
        font-style: normal;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        margin: 0;
        padding-left: .5%;
    }
    .beer-content-div{ 
        z-index: 2;
        width: 100vw;
    }
    .beer-top-right{
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 10% 7% 0 7%;
        background-color: #fff7e4;
    }
    .my-profile-header-beer{
        font-size: 4.25vw;
        line-height: 6.5vw;
        font-weight: 700;
        letter-spacing: .05vw;
        color: rgb(0, 0, 0);
        margin: 0 0 2% 0;
    }
    .user-profile-beer{
        font-size: 3.5vw;
        line-height: 5vw;
        font-weight: 400;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        margin: 0 0 5% 0;
    }
    .beer-flavors-header{
        font-size: 4vw;
        line-height: 5.5vw;
        font-weight: 700;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        margin: 3.5% 0 4.5% 0;
    }
    .beer-flav-img-container{
        height: 16vw;
        width: 16vw;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10vw;
        margin: 0 5% 7% 5%;
    }
    .beer-flavor-title{
        font-size: 2.75vw;
        line-height: 4.5vw;
        font-weight: 400;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        text-align: center;
        margin-top: 0%;
    }
    .beer-acid-sweetness-columns{
        display: flex;
        justify-content: space-between;
        padding: 6% 7.5% 8% 7.5%;
        background-color: #fff7e4;
    }
    .beer-acidity-bar{
        display: flex;
        align-items: center;
        height: 3vw;
        width: 100%;
        border: 1px rgb(150, 150, 150) solid;
        border-radius: 5vw;  
    }
    .beer-sweetness-bar{
        display: flex;
        align-items: center;
        height: 3.25vw;
        width: 100%;
        border: 1px rgb(150, 150, 150) solid;
        border-radius: 5vw;   
    }
    .beer-flavors-container{
        height: auto;
        display: flex;
        justify-content: left;
        width: 100%;
        padding-left: 0%;
    }
    .beer-flavor-box{
        width: 32%;
        justify-content: center;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .beer-acidity-header{
        margin: 0;
        padding-bottom: 3%;
        font-size: 3.5vw;
        margin-bottom: 2%;
        color: black;
        font-weight: 600;
        font-style: normal;
        letter-spacing: .07vw;
    }
    .beer-low-lable, .beer-high-lable{
        font-size: 2.75vw;
        line-height: 4.75vw;
        font-weight: 500;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        margin: 10% 3% 0 3%;
    }
    .triangle-section{
        padding: 1% 7% 7% 7%;
        background-color: #fff7e4;
    }
    .triangle-container{
        width: 50vw;
        height: 54vw;
        position: relative;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .bitter-text{
        font-size: 3vw;
        line-height: 4vw;
        font-weight: 400;
        color: black;
        text-align: center;
        margin: 0 0 1% 0 ;
        letter-spacing: .07vw;

    }
    .sweet-text{
        font-size: 3vw;
        font-weight: 400;
        color: black;
        margin: 0;
        position: absolute;
        bottom: 6.5%;
        left: 5%;
        letter-spacing: .07vw;
    }
    .dry-text{
        font-size: 3vw;
        font-weight: 400;
        color: black;
        margin: 0;
        position: absolute;
        bottom: 6.5%;
        right: 5%;
        letter-spacing: .07vw;
    }
    .triangle-img{
        width: 93%;
        left: 2.5%;
        top: 10%;
        height: auto;
        margin: 0 0 0 0;
        position: absolute;
        z-index: 0;
    }

    .bottom-section-container{
        background-color: #fdf9f1;
        padding: 3% 7% 5% 7%;
    }
    .beer-profile-header{
        font-size: 5.5vw;
        line-height: 6.5vw;
        font-weight: 700;
        letter-spacing: .07vw;
        color: rgb(0, 0, 0);
        margin: 5% 0 2% 0;
    }
    .beer-description{
        margin-bottom: 10%;
    }
    .beer-acid-sweetness-columns-bottom{
        display: flex;
        justify-content: space-between;
        padding: 0% 7% 5% 7%;
        background-color: transparent;
        background-color: #fdf9f1;
    }
    .l-acid-col-beer{
        display: flex;
        flex-direction: column;
        align-items: left;
        width: 35%;
    }
    .r-acid-col-beer{
        display: flex;
        flex-direction: column;
        justify-content: right;
        align-items: right;
        width: 70%;
    }
    .lively-bubbles{
        padding: 0;
        margin: 5% 0% 0% 0%;
        text-align: right;
    }
    .bottom-triangle-sect{
        background-color: #fdf9f1;
        padding: 3% 6% 7% 6%;
    }
    .beer-qr-code-section{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3% 0 4% 0%;
    width: 100%;
    background-color: #fdf9f1;
    }
}


@media screen and (min-width: 1000px){
  .beer-mobile-container{
    display: none;
  }

  .beer-desktop-container{
    display: block;
    position: static;
    height: auto;
  }
  .large-beer-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 25%;
    top: 0;
    left: 0; 
    background-color: transparent;
    z-index: 3;
    height: 92vh;
  }
  .beer-header{
    display: flex;
    position: relative;
    height: 11vh;
    padding-left: 25%;
    padding-right: 5%;
    border-bottom: 3px white solid;
    background-color: #fff7e4;
  }
  .beer-content{
    background-color: #fdf9f1;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    min-height: 79.5vh;
    padding-left: 25%;
    padding-right: 4%;
  }
  .beer-img{
    height: 80%;
    margin-top: 0%;
    margin-left: 0%;
  }
  .qr-code-section{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0% 0 0% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 0%;
    min-height: 100%;
    margin-right: 14px;
    margin-left: 0px;
    width: 130px;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
  }
  .share-img{
    width: 32%;
    margin-bottom: 0%;
    margin-right: 8px;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 13px;
    line-height: 15px;
    font-weight: 400;
    letter-spacing: .25px;
    margin: 0;
    text-align: left;
  }
  .logo-desk-container{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .brewery-logo{
    width: auto;
    height: 55%;
    margin: 0;
    padding: 0;
  }
  .beer-name-div{
    display: flex;
    justify-content: start;
    align-items: start;
    margin-bottom: 15px;
    margin-top: 10px;
  }
  .beer-title{
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
    color: rgb(26, 26, 26);
    margin: 0 0px 0 0;
    line-height: 25px;
    letter-spacing: .25px;
    width: 270px;
  }
  .beer-year{
    font-size: 20px;
    font-weight: 400;
    color: rgb(26, 26, 26);
    letter-spacing: .25px;
  }
  .beer-flavor-columns{
    display: flex;
    width: 100%;
  }
  .beer-l-col{
    width: 47%;
    margin-right: 3%;
  }
  .beer-profile-col{
    width: 47%;
    margin-right: 3%;
  }
  .r-col{
    width: 46%;
    margin-left: 4%;
  }
  .desktop-beer-profile-col{
    width: 46%;
    margin-left: 4%;
    display: flex;
    flex-direction: column;
  }
  .beer-profile-container{
    min-height: 120px;
  }
  .my-profile-header{
    margin: 0;
    line-height: 18px;
    font-size: 18px;
    padding-top: 0;
    padding-bottom: 10px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .beer-user-profile{
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
  }
  .beer-flavors-header{
    margin: 0;
    padding-top: 5px;
    padding-bottom: 0px;
    font-size: 16px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
    display: block;
    height: auto
  }
  .beer-flavors-container{
    min-height: 108px;
  }
  .flavor-box{
    height: 100%;
    margin-right: 22px;
    width: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 45px;
    border-radius: 30px;
    margin-bottom: 10px;
  }
  .user-flavor-img{
    width: 70%;
  }
  .flavor-title{
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
    text-align: center;
    margin: 0;
  }
  
  .carb-triangle-container{
    display: flex;
    align-items: left;
    width: 100%;
    margin-top: 0px;
  }
  .beer-acid-sweetness-columns{
    display: block;
    margin-top: 8px;
    width: 40%;
    background-color: transparent;
    padding: 10px 25px 0 0;
  }
  .beer-carbonation-col{
    display: block;
    width: 100%;
    margin-right: 0%;
    margin-bottom: 36px;
  }
  .carbonation-header, .body-header{
    margin: 0;
    padding-bottom: 7px;
    font-size: 13px;
    margin-bottom: 2px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .carbonation-bar, .body-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .beer-sweetness-col, .beer-body-col{
    display: block;
    width: 100%;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 30px;
  }
  .carbonation-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-flat-col{
    width: 30%;
  }
  .r-lively-col{
    width: 70%;
    display: flex;
    justify-content: end;
  }
  .flat-lable, .dry-label{
    font-size: 11px;
    margin-bottom: 3%;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 7px;
    margin-left: 2%;
    letter-spacing: .25px;
  }
  .lively-lable,.sweet-label{
    font-size: 11px;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 7px;
    padding-right: 2%;
    letter-spacing: .25px;
  }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .25px;
    font-size: 24px;
  }
  .loading-spinner {
    width: 70px;
    height: auto;
    border-radius: 0%;
    animation: spin 3s linear infinite;
    margin-bottom: 5px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .fade-in {
    opacity: 1;
    transition: opacity .7s ease-in;
  }
  
  .invisible {
    opacity: .8;
  }
  .loading-screen {
    opacity: 1;
    transition: opacity .2s ease-in;
  }

  .triangle-section{
        padding: 5% 0% 7% 0%;
        background-color: #fdf9f1;
  }
  .triangle-container{
        width: 170px;
        height: 150px;
        position: relative;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 5px;
        
    }
    .bitter-text{
        font-size:  11px;
        line-height: 20px;
        font-weight: 400;
        color: black;
        text-align: center;
        margin: -5px 0 1% 0 ;
        letter-spacing: .25px;

    }
    .sweet-text{
        font-size: 11px;
        font-weight: 400;
        color: black;
        margin: 0;
        position: absolute;
        bottom: 2.5px;
        left: 010%;
        letter-spacing: .25px;
    }
    .dry-text{
        font-size: 11px;
        font-weight: 400;
        color: black;
        margin: 0;
        position: absolute;
        bottom: 2.5px;
        right: 10%;
        letter-spacing: .07vw;
    }
    .triangle-img{
        width: 93%;
        left: 2.5%;
        top: 10%;
        height: auto;
        margin: 0 0 0 0;
        position: absolute;
        z-index: 0;
    }
    .body-label-columns{
    display: flex; 
    width: 100%;
    padding: 0 0 0 0px;
  }
}

@media screen and (min-width: 1400px) {

    .beer-mobile-container{
    display: none;
  }

  .beer-desktop-container{
    display: block;
    position: static;
    height: auto;
  }
  .large-beer-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 25%;
    top: 0;
    left: 0; 
    background-color: transparent;
    z-index: 3;
    height: 92vh;
  }
  .beer-header{
    display: flex;
    position: relative;
    height: 11vh;
    padding-left: 25%;
    padding-right: 5%;
    border-bottom: 3px white solid;
    background-color: #fff7e4;
  }
  .beer-content{
    background-color: #fdf9f1;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    min-height: 77.5vh;
    padding-left: 25%;
    padding-right: 4%;
  }
  .beer-img{
    height: 100%;
    margin-top: -30%;
    margin-left: 0%;
  }
  .qr-code-section{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0% 0 0% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 0%;
    min-height: 100%;
    margin-right: 14px;
    margin-left: 0px;
    width: 130px;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
  }
  .share-img{
    width: 32%;
    margin-bottom: 0%;
    margin-right: 8px;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 13px;
    line-height: 15px;
    font-weight: 400;
    letter-spacing: .25px;
    margin: 0;
    text-align: left;
  }
  .logo-desk-container{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .brewery-logo{
    width: auto;
    height: 55%;
    margin: 0;
    padding: 0;
  }
  .beer-name-div{
    display: flex;
    justify-content: start;
    align-items: start;
    margin-bottom: 15px;
    margin-top: 10px;
  }
  .beer-title{
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
    color: rgb(26, 26, 26);
    margin: 0 0px 0 0;
    line-height: 25px;
    letter-spacing: .25px;
    width: 270px;
  }
  .beer-year{
    font-size: 20px;
    font-weight: 400;
    color: rgb(26, 26, 26);
    letter-spacing: .25px;
  }
  .beer-flavor-columns{
    display: flex;
    width: 100%;
  }
  .beer-l-col{
    width: 45%;
    margin-right: 5%;
  }
  .beer-profile-col{
    width: 45%;
    margin-right: 5%;
  }
  .r-col{
    width: 46%;
    margin-left: 4%;
  }
  .desktop-beer-profile-col{
    width: 46%;
    margin-left: 4%;
    display: flex;
    flex-direction: column;
  }
  .beer-profile-container{
    min-height: 120px;
  }
  .my-profile-header{
    margin: 0;
    line-height: 18px;
    font-size: 18px;
    padding-top: 0;
    padding-bottom: 10px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .beer-user-profile{
    margin: 0;
    font-size: 15px;
    line-height: 22px;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
  }
  .beer-flavors-header{
    margin: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 16px;
    line-height: 24px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
    display: block;
    height: auto
  }
  .beer-flavors-container{
    min-height: 108px;
  }
  .flavor-box{
    height: 100%;
    margin-right: 22px;
    width: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 45px;
    border-radius: 30px;
    margin-bottom: 10px;
  }
  .user-flavor-img{
    width: 70%;
  }
  .flavor-title{
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
    text-align: center;
    margin: 0;
  }
  
  .carb-triangle-container{
    display: flex;
    align-items: left;
    width: 100%;
    margin-top: 0px;
  }
  .beer-acid-sweetness-columns{
    display: block;
    margin-top: 8px;
    width: 40%;
    background-color: transparent;
    padding: 5px 25px 0 0;
  }
  .beer-carbonation-col{
    display: block;
    width: 100%;
    margin-right: 0%;
    margin-bottom: 34.75px;
  }
  .carbonation-header, .body-header{
    margin: 0;
    padding-bottom: 5px;
    font-size: 15px;
    margin-bottom: 2px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .carbonation-bar, .body-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .beer-sweetness-col, .beer-body-col{
    display: block;
    width: 100%;
  }
  .body-label-columns{
    display: flex; 
    width: 112%;
    padding: 0 0 0 0px;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 30px;
  }
  .carbonation-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-flat-col{
    width: 30%;
  }
  .r-lively-col{
    width: 70%;
    display: flex;
    justify-content: end;
  }
  .flat-lable, .dry-label{
    font-size: 11px;
    margin-bottom: 3%;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 7px;
    margin-left: 0%;
    letter-spacing: .25px;
  }
  .lively-lable,.sweet-label{
    font-size: 11px;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 7px;
    padding-right: 2%;
    letter-spacing: .25px;
  }
  .sweet-label{
    text-align: right;
    margin-left: 5px;
  }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .25px;
    font-size: 24px;
  }
  .loading-spinner {
    width: 70px;
    height: auto;
    border-radius: 0%;
    animation: spin 3s linear infinite;
    margin-bottom: 5px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .fade-in {
    opacity: 1;
    transition: opacity .7s ease-in;
  }
  
  .invisible {
    opacity: .8;
  }
  .loading-screen {
    opacity: 1;
    transition: opacity .2s ease-in;
  }

  .triangle-section{
        padding: 2% 0% 7% 0%;
        background-color: #fdf9f1;
  }
  .triangle-container{
        width: 250px;
        height: 147px;
        position: relative;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 5px;
        
    }
    .bitter-text{
        font-size:  11px;
        line-height: 20px;
        font-weight: 400;
        color: black;
        text-align: center;
        margin: -5px 0 1% 0 ;
        letter-spacing: .25px;

    }
    .sweet-text{
        font-size: 11px;
        font-weight: 400;
        color: black;
        margin: 0;
        position: absolute;
        bottom: -2px;
        left: 55px;
        letter-spacing: .25px;
    }
    .dry-text{
        font-size: 11px;
        font-weight: 400;
        color: black;
        margin: 0;
        position: absolute;
        bottom: -2px;
        right: 60px;
        letter-spacing: .25px;
    }
    .triangle-img{
        width: 93%;
        left: 2.5%;
        top: 10%;
        height: auto;
        margin: 0 0 0 0;
        position: absolute;
        z-index: 0;
    }
}

@media screen and (min-width: 1900px){
     .beer-mobile-container{
    display: none;
  }

  .beer-desktop-container{
    display: block;
    position: static;
    height: auto;
  }
  .large-beer-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    top: 0;
    left: 0; 
    background-color: transparent;
    z-index: 3;
    height: 78vh;
  }
  .beer-header{
    display: flex;
    position: relative;
    height: 11vh;
    padding-left: 25%;
    padding-right: 5%;
    border-bottom: 3px white solid;
    background-color: #fff7e4;
  }
  .beer-content{
    background-color: #fdf9f1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 77.5vh;
    padding-left: 25%;
    padding-right: 4%;
  }
  .beer-img{
    height: 110%;
    margin-top: -20%;
    margin-left: 0%;
  }
  .qr-code-section{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0% 0 0% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 0%;
    min-height: 100%;
    margin-right: 14px;
    margin-left: 0px;
    width: 130px;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
  }
  .share-img{
    width: 32%;
    margin-bottom: 0%;
    margin-right: 8px;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 13px;
    line-height: 15px;
    font-weight: 400;
    letter-spacing: .25px;
    margin: 0;
    text-align: left;
  }
  .logo-desk-container{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .brewery-logo{
    width: auto;
    height: 55%;
    margin: 0;
    padding: 0;
  }
  .beer-name-div{
    display: flex;
    justify-content: start;
    align-items: start;
    margin-bottom: 15px;
    margin-top: 10px;
  }
  .beer-title{
    font-size: 46px;
    font-weight: 700;
    font-style: normal;
    color: rgb(26, 26, 26);
    margin: 0 0px 0 0;
    line-height: 40px;
    letter-spacing: .25px;
    width: 500px;
  }
  .beer-year{
    font-size: 30px;
    font-weight: 400;
    color: rgb(26, 26, 26);
    letter-spacing: .25px;
  }
  .beer-flavor-columns{
    display: flex;
    width: 100%;
  }
  .beer-l-col{
    width: 44%;
    margin-right: 6%;
  }
  .beer-profile-col{
    width: 44%;
    margin-right: 6%;
  }
  .r-col{
    width: 44%;
    margin-left: 6%;
  }
  .desktop-beer-profile-col{
    width: 44%;
    margin-left: 6%;
    display: flex;
    flex-direction: column;
  }
  .beer-profile-container{
    min-height: 130px;
  }
  .my-profile-header{
    margin: 0;
    line-height: 22px;
    font-size: 22px;
    padding-top: 0;
    padding-bottom: 10px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .beer-user-profile{
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
  }
  .beer-flavors-header{
    margin: 0;
    padding-top: 10px;
    padding-bottom: 15px;
    font-size: 18px;
    line-height: 24px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
    display: block;
    height: auto
  }
  .beer-flavors-container{
    min-height: 135px;
    justify-content: left;
    padding-left: 10px;
  }
  .flavor-box{
    height: 100%;
    margin-right: 22px;
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 63px;
    width: 63px;
    border-radius: 40px;
    margin-bottom: 10px;
  }
  .user-flavor-img{
    width: 70%;
  }
  .flavor-title{
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
    text-align: center;
    margin: 0;
  }
  
  .carb-triangle-container{
    display: flex;
    align-items: left;
    width: 100%;
    margin-top: 0px;
  }
  .beer-acid-sweetness-columns{
    display: block;
    margin-top: 8px;
    width: 30%;
    background-color: transparent;
    padding: 5px 25px 0 0;
  }
  .beer-carbonation-col{
    display: block;
    width: 100%;
    margin-right: 0%;
    margin-bottom: 40px;
  }
  .carbonation-header, .body-header{
    margin: 0;
    padding-bottom: 5px;
    font-size: 15px;
    margin-bottom: 2px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .carbonation-bar, .body-bar{
    display: flex;
    align-items: center;
    height: 15px;
    width: 100%;
    border: 1px rgb(133, 133, 133) solid;
    border-radius: 5vw;
  }
  .beer-sweetness-col, .beer-body-col{
    display: block;
    width: 100%;
  }
  .body-label-columns{
    display: flex; 
    width: 100%;
    padding: 0 0 0 0px;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 30px;
  }
  .carbonation-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-flat-col{
    width: 30%;
  }
  .r-lively-col{
    width: 70%;
    display: flex;
    justify-content: end;
  }
  .flat-lable, .dry-label{
    font-size: 12px;
    color: black;
    font-weight: 500;
    margin: 0;
    padding-top: 7px;
    margin-left: 0%;
    letter-spacing: .25px;
  }
  .lively-lable,.sweet-label{
    font-size: 12px;
    color: black;
    font-weight: 500;
    margin: 0;
    padding-top: 7px;
    padding-right: 2%;
    letter-spacing: .25px;
  }
  .sweet-label{
    text-align: right;
    margin-left: 5px;
  }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .25px;
    font-size: 24px;
  }
  .loading-spinner {
    width: 70px;
    height: auto;
    border-radius: 0%;
    animation: spin 3s linear infinite;
    margin-bottom: 5px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .fade-in {
    opacity: 1;
    transition: opacity .7s ease-in;
  }
  
  .invisible {
    opacity: .8;
  }
  .loading-screen {
    opacity: 1;
    transition: opacity .2s ease-in;
  }

  .triangle-section{
        padding: 2% 0% 7% 0%;
        background-color: #fdf9f1;
  }
  .triangle-container{
        width: 250px;
        height: 163.5px;
        position: relative;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 3px;
        
    }
    .bitter-text{
        font-size:  12px;
        line-height: 20px;
        font-weight: 500;
        color: black;
        text-align: center;
        margin: -5px 0 1% 0 ;
        letter-spacing: .25px;

    }
    .sweet-text{
        font-size: 12px;
        font-weight: 500;
        color: black;
        margin: 0;
        position: absolute;
        bottom: -3px;
        left: 50px;
        letter-spacing: .25px;
    }
    .dry-text{
        font-size: 12px;
        font-weight: 500;
        color: black;
        margin: 0;
        position: absolute;
        bottom: -3px;
        right: 52px;
        letter-spacing: .25px;
    }
    .triangle-img{
        width: 93%;
        left: 2.5%;
        top: 10%;
        height: auto;
        margin: 0 0 0 0;
        position: absolute;
        z-index: 0;
    } 
}
`, "",{"version":3,"sources":["webpack://./src/components/beer.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;;AAEzB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;;;AAIA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,YAAY;QACZ,oBAAoB;QACpB,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,UAAU;QACV,YAAY;QACZ,oBAAoB;QACpB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,mBAAmB;QACnB,SAAS;QACT,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,yBAAyB;IAC7B;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,qBAAqB;IACzB;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,WAAW;QACX,oCAAoC;QACpC,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,WAAW;QACX,oCAAoC;QACpC,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,aAAa;QACb,qBAAqB;QACrB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,aAAa;QACb,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;IACzB;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,qBAAqB;;IAEzB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,QAAQ;QACR,qBAAqB;IACzB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,oBAAoB;QACpB,6BAA6B;QAC7B,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,sBAAsB;QACtB,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,UAAU;QACV,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,yBAAyB;QACzB,oBAAoB;IACxB;IACA;IACA,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB;AACJ;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd;EACF;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,6BAA6B;IAC7B,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;QACM,oBAAoB;QACpB,yBAAyB;EAC/B;EACA;QACM,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;;IAEpB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;;IAEzB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,UAAU;IACd;IACA;IACA,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;;IAEI;IACA,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd;EACF;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;QACM,oBAAoB;QACpB,yBAAyB;EAC/B;EACA;QACM,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;;IAEpB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;;IAEzB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,UAAU;IACd;AACJ;;AAEA;KACK;IACD,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd;EACF;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;QACM,oBAAoB;QACpB,yBAAyB;EAC/B;EACA;QACM,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;;IAEpB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;;IAEzB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,UAAU;IACd;AACJ","sourcesContent":[".beer-desktop-container{\n    height: 30vw;\n    display: none;\n}\n.beer-title-container{\n    display: flex;\n    height: 15vw;\n    justify-content: end;\n    align-items: end; \n    background-color: #fff7e4;\n    padding-top: 10%;\n}\n.l-beer-title{\n    width: 70%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: end;\n    padding-left: 7%;\n}\n.r-beer-title{\n    display: flex;\n    width: 50%;\n    height: 100%;\n    justify-content: end;\n    align-items: end;\n    padding-right: 7%;\n}\n.beer-image{\n    height: 20vw;\n    width: auto;\n    margin-bottom: 3.5%;\n}\n.brewery-logo{\n    height: 72%;\n    width: auto;\n    margin-right: 5%;\n    margin-bottom: 4.5%;\n}\n.beer-title{\n  margin-right: 0%;\n  font-size: 7.5vw;\n  line-height: 8.25vw;;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: .05vw;\n  color: rgb(0, 0, 0);\n  margin: 0 0 1.25% 0;\n}\n.beer-year{\n  font-size: 4.5vw;\n  line-height: 5.25vw;\n  font-weight: 400;\n  font-style: normal;\n  letter-spacing: .05vw;\n  color: rgb(0, 0, 0);\n  margin: 0;\n  padding-left: .75%;\n}\n.beer-content-div{ \n  z-index: 2;\n  width: 100vw;\n}\n.beer-top-right{\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 13% 7% 5% 7%;\n    background-color: #fff7e4;\n}\n.my-profile-header-beer{\n    font-size: 5.5vw;\n    line-height: 6.5vw;\n    font-weight: 700;\n    letter-spacing: .05vw;\n    color: rgb(0, 0, 0);\n    margin: 0 0 2% 0;\n}\n.user-profile-beer{\n    font-size: 4.25vw;\n    line-height: 6vw;\n    font-weight: 400;\n    letter-spacing: .05vw;\n    color: rgb(0, 0, 0);\n    margin: 0 0 3.25% 0;\n}\n.beer-flavors-header{\n    font-size: 5vw;\n    line-height: 5.5vw;\n    font-weight: 700;\n    letter-spacing: .05vw;\n    color: rgb(0, 0, 0);\n    margin: 11.5% 0 5.5% 0;\n}\n.beer-flav-img-container{\n    height: 17vw;\n    width: 17vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10vw;\n    margin: 0 auto 9% auto;\n}\n.beer-flavor-title{\n    font-size: 3.5vw;\n    line-height: 4.5vw;\n    font-weight: 400;\n    letter-spacing: .05vw;\n    color: rgb(0, 0, 0);\n    text-align: center;\n    margin-top: 0%;\n}\n.beer-flavor-box{\n    width: 33%;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n.beer-acid-sweetness-columns{\n    display: flex;\n    justify-content: space-between;\n    padding: 6% 7.25% 8% 7.25%;\n    background-color: #fff7e4;\n}\n.beer-acidity-bar{\n    display: flex;\n    align-items: center;\n    height: 4vw;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;  \n}\n.beer-sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 4vw;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;   \n}\n.beer-flavors-container{\n    height: auto;\n    display: flex;\n    padding-left: 0%;\n    justify-content: left;\n}\n.beer-acidity-header{\n    margin: 0;\n    padding-bottom: 3%;\n    font-size: 4.25vw;\n    margin-bottom: 2%;\n    color: black;\n    font-weight: 600;\n    font-style: normal;\n    letter-spacing: .05vw;\n}\n.beer-low-lable, .beer-high-lable{\n    font-size: 3.25vw;\n    line-height: 4.75vw;\n    font-weight: 500;\n    letter-spacing: .05vw;\n    color: rgb(0, 0, 0);\n    margin: 10% 3% 0 3%;\n}\n.triangle-section{\n    padding: 2% 7% 8% 7%;\n    background-color: #fff7e4;\n}\n.triangle-container{\n    width: 53vw;\n    height: 53vw;\n    position: relative;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.bitter-text{\n    font-size: 3.5vw;\n    font-weight: 400;\n    color: black;\n    text-align: center;\n    margin: 0% 0 2% 0 ;\n    letter-spacing: .05vw;\n\n}\n.sweet-text{\n    font-size: 3.5vw;\n    font-weight: 400;\n    color: black;\n    margin: 0;\n    position: absolute;\n    bottom: 3.75%;\n    left: 6%;\n    letter-spacing: .07vw;\n}\n.dry-text{\n    font-size: 3.5vw;\n    font-weight: 400;\n    color: black;\n    margin: 0;\n    position: absolute;\n    bottom: 3.75%;\n    right: 8%;\n    letter-spacing: .07vw;\n}\n.triangle-img{\n    width: 93%;\n    left: 2.5%;\n    top: 10%;\n    height: auto;\n    margin: 0 0 0 0;\n    position: absolute;\n    z-index: 0;\n}\n\n.bottom-section-container{\n    background-color: #fdf9f1;\n    padding: 3% 7% 5% 7%;\n}\n.beer-profile-header{\n    font-size: 5.5vw;\n    line-height: 6.5vw;\n    font-weight: 700;\n    letter-spacing: .05vw;\n    color: rgb(0, 0, 0);\n    margin: 5% 0 2% 0;\n}\n.beer-description{\n    margin-bottom: 10%;\n}\n.beer-acid-sweetness-columns-bottom{\n    display: flex;\n    justify-content: space-between;\n    padding: 3% 7.25% 10% 7.25%;\n    background-color: transparent;\n    background-color: #fdf9f1;\n}\n.l-acid-col-beer{\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    width: 35%;\n}\n.r-acid-col-beer{\n    display: flex;\n    flex-direction: column;\n    justify-content: right;\n    align-items: right;\n    width: 70%;\n}\n.lively-bubbles{\n    padding: 0;\n    margin: 5% 0% 0% 0%;\n    text-align: right;\n}\n.bottom-triangle-sect{\n    background-color: #fdf9f1;\n    padding: 3% 7% 7% 7%;\n}\n.beer-qr-code-section{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3% 0 4% 0%;\n  width: 100%;\n  background-color: #fdf9f1;\n}\n\n\n\n@media only screen and (min-width: 700px) and (min-height: 1000px){\n    .beer-desktop-container{\n        display: none;\n    }\n    .beer-title-container{\n        display: flex;\n        height: 12vw;\n        justify-content: end;\n        align-items: end; \n        background-color: #fff7e4;\n        padding-top: 10%;\n    }\n    .l-beer-title{\n        width: 70%;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: left;\n        justify-content: end;\n        padding-left: 7%;\n    }\n    .r-beer-title{\n        display: flex;\n        width: 50%;\n        height: 100%;\n        justify-content: end;\n        align-items: end;\n        padding-right: 7%;\n    }\n    .beer-image{\n        height: 17vw;\n        width: auto;\n        margin-bottom: 4%;\n    }\n    .brewery-logo{\n        height: 78%;\n        width: auto;\n        margin-right: 7%;\n        margin-bottom: 4.5%;\n    }\n    .beer-title{\n        margin-right: 0%;\n        font-size: 5.75vw;\n        line-height: 6.5vw;;\n        font-weight: 700;\n        font-style: normal;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        margin: 0 0 1.5% 0;\n    }\n    .beer-year{\n        font-size: 4vw;\n        line-height: 5vw;\n        font-weight: 400;\n        font-style: normal;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        margin: 0;\n        padding-left: .5%;\n    }\n    .beer-content-div{ \n        z-index: 2;\n        width: 100vw;\n    }\n    .beer-top-right{\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        padding: 10% 7% 0 7%;\n        background-color: #fff7e4;\n    }\n    .my-profile-header-beer{\n        font-size: 4.25vw;\n        line-height: 6.5vw;\n        font-weight: 700;\n        letter-spacing: .05vw;\n        color: rgb(0, 0, 0);\n        margin: 0 0 2% 0;\n    }\n    .user-profile-beer{\n        font-size: 3.5vw;\n        line-height: 5vw;\n        font-weight: 400;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        margin: 0 0 5% 0;\n    }\n    .beer-flavors-header{\n        font-size: 4vw;\n        line-height: 5.5vw;\n        font-weight: 700;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        margin: 3.5% 0 4.5% 0;\n    }\n    .beer-flav-img-container{\n        height: 16vw;\n        width: 16vw;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 10vw;\n        margin: 0 5% 7% 5%;\n    }\n    .beer-flavor-title{\n        font-size: 2.75vw;\n        line-height: 4.5vw;\n        font-weight: 400;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        text-align: center;\n        margin-top: 0%;\n    }\n    .beer-acid-sweetness-columns{\n        display: flex;\n        justify-content: space-between;\n        padding: 6% 7.5% 8% 7.5%;\n        background-color: #fff7e4;\n    }\n    .beer-acidity-bar{\n        display: flex;\n        align-items: center;\n        height: 3vw;\n        width: 100%;\n        border: 1px rgb(150, 150, 150) solid;\n        border-radius: 5vw;  \n    }\n    .beer-sweetness-bar{\n        display: flex;\n        align-items: center;\n        height: 3.25vw;\n        width: 100%;\n        border: 1px rgb(150, 150, 150) solid;\n        border-radius: 5vw;   \n    }\n    .beer-flavors-container{\n        height: auto;\n        display: flex;\n        justify-content: left;\n        width: 100%;\n        padding-left: 0%;\n    }\n    .beer-flavor-box{\n        width: 32%;\n        justify-content: center;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n    .beer-acidity-header{\n        margin: 0;\n        padding-bottom: 3%;\n        font-size: 3.5vw;\n        margin-bottom: 2%;\n        color: black;\n        font-weight: 600;\n        font-style: normal;\n        letter-spacing: .07vw;\n    }\n    .beer-low-lable, .beer-high-lable{\n        font-size: 2.75vw;\n        line-height: 4.75vw;\n        font-weight: 500;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        margin: 10% 3% 0 3%;\n    }\n    .triangle-section{\n        padding: 1% 7% 7% 7%;\n        background-color: #fff7e4;\n    }\n    .triangle-container{\n        width: 50vw;\n        height: 54vw;\n        position: relative;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n    .bitter-text{\n        font-size: 3vw;\n        line-height: 4vw;\n        font-weight: 400;\n        color: black;\n        text-align: center;\n        margin: 0 0 1% 0 ;\n        letter-spacing: .07vw;\n\n    }\n    .sweet-text{\n        font-size: 3vw;\n        font-weight: 400;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: 6.5%;\n        left: 5%;\n        letter-spacing: .07vw;\n    }\n    .dry-text{\n        font-size: 3vw;\n        font-weight: 400;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: 6.5%;\n        right: 5%;\n        letter-spacing: .07vw;\n    }\n    .triangle-img{\n        width: 93%;\n        left: 2.5%;\n        top: 10%;\n        height: auto;\n        margin: 0 0 0 0;\n        position: absolute;\n        z-index: 0;\n    }\n\n    .bottom-section-container{\n        background-color: #fdf9f1;\n        padding: 3% 7% 5% 7%;\n    }\n    .beer-profile-header{\n        font-size: 5.5vw;\n        line-height: 6.5vw;\n        font-weight: 700;\n        letter-spacing: .07vw;\n        color: rgb(0, 0, 0);\n        margin: 5% 0 2% 0;\n    }\n    .beer-description{\n        margin-bottom: 10%;\n    }\n    .beer-acid-sweetness-columns-bottom{\n        display: flex;\n        justify-content: space-between;\n        padding: 0% 7% 5% 7%;\n        background-color: transparent;\n        background-color: #fdf9f1;\n    }\n    .l-acid-col-beer{\n        display: flex;\n        flex-direction: column;\n        align-items: left;\n        width: 35%;\n    }\n    .r-acid-col-beer{\n        display: flex;\n        flex-direction: column;\n        justify-content: right;\n        align-items: right;\n        width: 70%;\n    }\n    .lively-bubbles{\n        padding: 0;\n        margin: 5% 0% 0% 0%;\n        text-align: right;\n    }\n    .bottom-triangle-sect{\n        background-color: #fdf9f1;\n        padding: 3% 6% 7% 6%;\n    }\n    .beer-qr-code-section{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 3% 0 4% 0%;\n    width: 100%;\n    background-color: #fdf9f1;\n    }\n}\n\n\n@media screen and (min-width: 1000px){\n  .beer-mobile-container{\n    display: none;\n  }\n\n  .beer-desktop-container{\n    display: block;\n    position: static;\n    height: auto;\n  }\n  .large-beer-container{\n    display: flex;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    width: 25%;\n    top: 0;\n    left: 0; \n    background-color: transparent;\n    z-index: 3;\n    height: 92vh;\n  }\n  .beer-header{\n    display: flex;\n    position: relative;\n    height: 11vh;\n    padding-left: 25%;\n    padding-right: 5%;\n    border-bottom: 3px white solid;\n    background-color: #fff7e4;\n  }\n  .beer-content{\n    background-color: #fdf9f1;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: center;\n    min-height: 79.5vh;\n    padding-left: 25%;\n    padding-right: 4%;\n  }\n  .beer-img{\n    height: 80%;\n    margin-top: 0%;\n    margin-left: 0%;\n  }\n  .qr-code-section{\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 0% 0 0% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 0%;\n    min-height: 100%;\n    margin-right: 14px;\n    margin-left: 0px;\n    width: 130px;\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n  .share-img{\n    width: 32%;\n    margin-bottom: 0%;\n    margin-right: 8px;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 13px;\n    line-height: 15px;\n    font-weight: 400;\n    letter-spacing: .25px;\n    margin: 0;\n    text-align: left;\n  }\n  .logo-desk-container{\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .brewery-logo{\n    width: auto;\n    height: 55%;\n    margin: 0;\n    padding: 0;\n  }\n  .beer-name-div{\n    display: flex;\n    justify-content: start;\n    align-items: start;\n    margin-bottom: 15px;\n    margin-top: 10px;\n  }\n  .beer-title{\n    font-size: 32px;\n    font-weight: 700;\n    font-style: normal;\n    color: rgb(26, 26, 26);\n    margin: 0 0px 0 0;\n    line-height: 25px;\n    letter-spacing: .25px;\n    width: 270px;\n  }\n  .beer-year{\n    font-size: 20px;\n    font-weight: 400;\n    color: rgb(26, 26, 26);\n    letter-spacing: .25px;\n  }\n  .beer-flavor-columns{\n    display: flex;\n    width: 100%;\n  }\n  .beer-l-col{\n    width: 47%;\n    margin-right: 3%;\n  }\n  .beer-profile-col{\n    width: 47%;\n    margin-right: 3%;\n  }\n  .r-col{\n    width: 46%;\n    margin-left: 4%;\n  }\n  .desktop-beer-profile-col{\n    width: 46%;\n    margin-left: 4%;\n    display: flex;\n    flex-direction: column;\n  }\n  .beer-profile-container{\n    min-height: 120px;\n  }\n  .my-profile-header{\n    margin: 0;\n    line-height: 18px;\n    font-size: 18px;\n    padding-top: 0;\n    padding-bottom: 10px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .beer-user-profile{\n    margin: 0;\n    font-size: 14px;\n    line-height: 20px;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .beer-flavors-header{\n    margin: 0;\n    padding-top: 5px;\n    padding-bottom: 0px;\n    font-size: 16px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n    display: block;\n    height: auto\n  }\n  .beer-flavors-container{\n    min-height: 108px;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 22px;\n    width: 50px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 45px;\n    width: 45px;\n    border-radius: 30px;\n    margin-bottom: 10px;\n  }\n  .user-flavor-img{\n    width: 70%;\n  }\n  .flavor-title{\n    font-size: 11px;\n    line-height: 14px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n    text-align: center;\n    margin: 0;\n  }\n  \n  .carb-triangle-container{\n    display: flex;\n    align-items: left;\n    width: 100%;\n    margin-top: 0px;\n  }\n  .beer-acid-sweetness-columns{\n    display: block;\n    margin-top: 8px;\n    width: 40%;\n    background-color: transparent;\n    padding: 10px 25px 0 0;\n  }\n  .beer-carbonation-col{\n    display: block;\n    width: 100%;\n    margin-right: 0%;\n    margin-bottom: 36px;\n  }\n  .carbonation-header, .body-header{\n    margin: 0;\n    padding-bottom: 7px;\n    font-size: 13px;\n    margin-bottom: 2px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .carbonation-bar, .body-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .beer-sweetness-col, .beer-body-col{\n    display: block;\n    width: 100%;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 30px;\n  }\n  .carbonation-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-flat-col{\n    width: 30%;\n  }\n  .r-lively-col{\n    width: 70%;\n    display: flex;\n    justify-content: end;\n  }\n  .flat-lable, .dry-label{\n    font-size: 11px;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 7px;\n    margin-left: 2%;\n    letter-spacing: .25px;\n  }\n  .lively-lable,.sweet-label{\n    font-size: 11px;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 7px;\n    padding-right: 2%;\n    letter-spacing: .25px;\n  }\n\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .25px;\n    font-size: 24px;\n  }\n  .loading-spinner {\n    width: 70px;\n    height: auto;\n    border-radius: 0%;\n    animation: spin 3s linear infinite;\n    margin-bottom: 5px;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  .fade-in {\n    opacity: 1;\n    transition: opacity .7s ease-in;\n  }\n  \n  .invisible {\n    opacity: .8;\n  }\n  .loading-screen {\n    opacity: 1;\n    transition: opacity .2s ease-in;\n  }\n\n  .triangle-section{\n        padding: 5% 0% 7% 0%;\n        background-color: #fdf9f1;\n  }\n  .triangle-container{\n        width: 170px;\n        height: 150px;\n        position: relative;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding-top: 5px;\n        \n    }\n    .bitter-text{\n        font-size:  11px;\n        line-height: 20px;\n        font-weight: 400;\n        color: black;\n        text-align: center;\n        margin: -5px 0 1% 0 ;\n        letter-spacing: .25px;\n\n    }\n    .sweet-text{\n        font-size: 11px;\n        font-weight: 400;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: 2.5px;\n        left: 010%;\n        letter-spacing: .25px;\n    }\n    .dry-text{\n        font-size: 11px;\n        font-weight: 400;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: 2.5px;\n        right: 10%;\n        letter-spacing: .07vw;\n    }\n    .triangle-img{\n        width: 93%;\n        left: 2.5%;\n        top: 10%;\n        height: auto;\n        margin: 0 0 0 0;\n        position: absolute;\n        z-index: 0;\n    }\n    .body-label-columns{\n    display: flex; \n    width: 100%;\n    padding: 0 0 0 0px;\n  }\n}\n\n@media screen and (min-width: 1400px) {\n\n    .beer-mobile-container{\n    display: none;\n  }\n\n  .beer-desktop-container{\n    display: block;\n    position: static;\n    height: auto;\n  }\n  .large-beer-container{\n    display: flex;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    width: 25%;\n    top: 0;\n    left: 0; \n    background-color: transparent;\n    z-index: 3;\n    height: 92vh;\n  }\n  .beer-header{\n    display: flex;\n    position: relative;\n    height: 11vh;\n    padding-left: 25%;\n    padding-right: 5%;\n    border-bottom: 3px white solid;\n    background-color: #fff7e4;\n  }\n  .beer-content{\n    background-color: #fdf9f1;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: center;\n    min-height: 77.5vh;\n    padding-left: 25%;\n    padding-right: 4%;\n  }\n  .beer-img{\n    height: 100%;\n    margin-top: -30%;\n    margin-left: 0%;\n  }\n  .qr-code-section{\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 0% 0 0% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 0%;\n    min-height: 100%;\n    margin-right: 14px;\n    margin-left: 0px;\n    width: 130px;\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n  .share-img{\n    width: 32%;\n    margin-bottom: 0%;\n    margin-right: 8px;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 13px;\n    line-height: 15px;\n    font-weight: 400;\n    letter-spacing: .25px;\n    margin: 0;\n    text-align: left;\n  }\n  .logo-desk-container{\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .brewery-logo{\n    width: auto;\n    height: 55%;\n    margin: 0;\n    padding: 0;\n  }\n  .beer-name-div{\n    display: flex;\n    justify-content: start;\n    align-items: start;\n    margin-bottom: 15px;\n    margin-top: 10px;\n  }\n  .beer-title{\n    font-size: 32px;\n    font-weight: 700;\n    font-style: normal;\n    color: rgb(26, 26, 26);\n    margin: 0 0px 0 0;\n    line-height: 25px;\n    letter-spacing: .25px;\n    width: 270px;\n  }\n  .beer-year{\n    font-size: 20px;\n    font-weight: 400;\n    color: rgb(26, 26, 26);\n    letter-spacing: .25px;\n  }\n  .beer-flavor-columns{\n    display: flex;\n    width: 100%;\n  }\n  .beer-l-col{\n    width: 45%;\n    margin-right: 5%;\n  }\n  .beer-profile-col{\n    width: 45%;\n    margin-right: 5%;\n  }\n  .r-col{\n    width: 46%;\n    margin-left: 4%;\n  }\n  .desktop-beer-profile-col{\n    width: 46%;\n    margin-left: 4%;\n    display: flex;\n    flex-direction: column;\n  }\n  .beer-profile-container{\n    min-height: 120px;\n  }\n  .my-profile-header{\n    margin: 0;\n    line-height: 18px;\n    font-size: 18px;\n    padding-top: 0;\n    padding-bottom: 10px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .beer-user-profile{\n    margin: 0;\n    font-size: 15px;\n    line-height: 22px;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .beer-flavors-header{\n    margin: 0;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    font-size: 16px;\n    line-height: 24px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n    display: block;\n    height: auto\n  }\n  .beer-flavors-container{\n    min-height: 108px;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 22px;\n    width: 50px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 45px;\n    width: 45px;\n    border-radius: 30px;\n    margin-bottom: 10px;\n  }\n  .user-flavor-img{\n    width: 70%;\n  }\n  .flavor-title{\n    font-size: 11px;\n    line-height: 14px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n    text-align: center;\n    margin: 0;\n  }\n  \n  .carb-triangle-container{\n    display: flex;\n    align-items: left;\n    width: 100%;\n    margin-top: 0px;\n  }\n  .beer-acid-sweetness-columns{\n    display: block;\n    margin-top: 8px;\n    width: 40%;\n    background-color: transparent;\n    padding: 5px 25px 0 0;\n  }\n  .beer-carbonation-col{\n    display: block;\n    width: 100%;\n    margin-right: 0%;\n    margin-bottom: 34.75px;\n  }\n  .carbonation-header, .body-header{\n    margin: 0;\n    padding-bottom: 5px;\n    font-size: 15px;\n    margin-bottom: 2px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .carbonation-bar, .body-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .beer-sweetness-col, .beer-body-col{\n    display: block;\n    width: 100%;\n  }\n  .body-label-columns{\n    display: flex; \n    width: 112%;\n    padding: 0 0 0 0px;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 30px;\n  }\n  .carbonation-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-flat-col{\n    width: 30%;\n  }\n  .r-lively-col{\n    width: 70%;\n    display: flex;\n    justify-content: end;\n  }\n  .flat-lable, .dry-label{\n    font-size: 11px;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 7px;\n    margin-left: 0%;\n    letter-spacing: .25px;\n  }\n  .lively-lable,.sweet-label{\n    font-size: 11px;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 7px;\n    padding-right: 2%;\n    letter-spacing: .25px;\n  }\n  .sweet-label{\n    text-align: right;\n    margin-left: 5px;\n  }\n\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .25px;\n    font-size: 24px;\n  }\n  .loading-spinner {\n    width: 70px;\n    height: auto;\n    border-radius: 0%;\n    animation: spin 3s linear infinite;\n    margin-bottom: 5px;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  .fade-in {\n    opacity: 1;\n    transition: opacity .7s ease-in;\n  }\n  \n  .invisible {\n    opacity: .8;\n  }\n  .loading-screen {\n    opacity: 1;\n    transition: opacity .2s ease-in;\n  }\n\n  .triangle-section{\n        padding: 2% 0% 7% 0%;\n        background-color: #fdf9f1;\n  }\n  .triangle-container{\n        width: 250px;\n        height: 147px;\n        position: relative;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding-top: 5px;\n        \n    }\n    .bitter-text{\n        font-size:  11px;\n        line-height: 20px;\n        font-weight: 400;\n        color: black;\n        text-align: center;\n        margin: -5px 0 1% 0 ;\n        letter-spacing: .25px;\n\n    }\n    .sweet-text{\n        font-size: 11px;\n        font-weight: 400;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: -2px;\n        left: 55px;\n        letter-spacing: .25px;\n    }\n    .dry-text{\n        font-size: 11px;\n        font-weight: 400;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: -2px;\n        right: 60px;\n        letter-spacing: .25px;\n    }\n    .triangle-img{\n        width: 93%;\n        left: 2.5%;\n        top: 10%;\n        height: auto;\n        margin: 0 0 0 0;\n        position: absolute;\n        z-index: 0;\n    }\n}\n\n@media screen and (min-width: 1900px){\n     .beer-mobile-container{\n    display: none;\n  }\n\n  .beer-desktop-container{\n    display: block;\n    position: static;\n    height: auto;\n  }\n  .large-beer-container{\n    display: flex;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 25%;\n    top: 0;\n    left: 0; \n    background-color: transparent;\n    z-index: 3;\n    height: 78vh;\n  }\n  .beer-header{\n    display: flex;\n    position: relative;\n    height: 11vh;\n    padding-left: 25%;\n    padding-right: 5%;\n    border-bottom: 3px white solid;\n    background-color: #fff7e4;\n  }\n  .beer-content{\n    background-color: #fdf9f1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 77.5vh;\n    padding-left: 25%;\n    padding-right: 4%;\n  }\n  .beer-img{\n    height: 110%;\n    margin-top: -20%;\n    margin-left: 0%;\n  }\n  .qr-code-section{\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 0% 0 0% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 0%;\n    min-height: 100%;\n    margin-right: 14px;\n    margin-left: 0px;\n    width: 130px;\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n  .share-img{\n    width: 32%;\n    margin-bottom: 0%;\n    margin-right: 8px;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 13px;\n    line-height: 15px;\n    font-weight: 400;\n    letter-spacing: .25px;\n    margin: 0;\n    text-align: left;\n  }\n  .logo-desk-container{\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .brewery-logo{\n    width: auto;\n    height: 55%;\n    margin: 0;\n    padding: 0;\n  }\n  .beer-name-div{\n    display: flex;\n    justify-content: start;\n    align-items: start;\n    margin-bottom: 15px;\n    margin-top: 10px;\n  }\n  .beer-title{\n    font-size: 46px;\n    font-weight: 700;\n    font-style: normal;\n    color: rgb(26, 26, 26);\n    margin: 0 0px 0 0;\n    line-height: 40px;\n    letter-spacing: .25px;\n    width: 500px;\n  }\n  .beer-year{\n    font-size: 30px;\n    font-weight: 400;\n    color: rgb(26, 26, 26);\n    letter-spacing: .25px;\n  }\n  .beer-flavor-columns{\n    display: flex;\n    width: 100%;\n  }\n  .beer-l-col{\n    width: 44%;\n    margin-right: 6%;\n  }\n  .beer-profile-col{\n    width: 44%;\n    margin-right: 6%;\n  }\n  .r-col{\n    width: 44%;\n    margin-left: 6%;\n  }\n  .desktop-beer-profile-col{\n    width: 44%;\n    margin-left: 6%;\n    display: flex;\n    flex-direction: column;\n  }\n  .beer-profile-container{\n    min-height: 130px;\n  }\n  .my-profile-header{\n    margin: 0;\n    line-height: 22px;\n    font-size: 22px;\n    padding-top: 0;\n    padding-bottom: 10px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .beer-user-profile{\n    margin: 0;\n    font-size: 16px;\n    line-height: 24px;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .beer-flavors-header{\n    margin: 0;\n    padding-top: 10px;\n    padding-bottom: 15px;\n    font-size: 18px;\n    line-height: 24px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n    display: block;\n    height: auto\n  }\n  .beer-flavors-container{\n    min-height: 135px;\n    justify-content: left;\n    padding-left: 10px;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 22px;\n    width: 70px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 63px;\n    width: 63px;\n    border-radius: 40px;\n    margin-bottom: 10px;\n  }\n  .user-flavor-img{\n    width: 70%;\n  }\n  .flavor-title{\n    font-size: 11px;\n    line-height: 14px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n    text-align: center;\n    margin: 0;\n  }\n  \n  .carb-triangle-container{\n    display: flex;\n    align-items: left;\n    width: 100%;\n    margin-top: 0px;\n  }\n  .beer-acid-sweetness-columns{\n    display: block;\n    margin-top: 8px;\n    width: 30%;\n    background-color: transparent;\n    padding: 5px 25px 0 0;\n  }\n  .beer-carbonation-col{\n    display: block;\n    width: 100%;\n    margin-right: 0%;\n    margin-bottom: 40px;\n  }\n  .carbonation-header, .body-header{\n    margin: 0;\n    padding-bottom: 5px;\n    font-size: 15px;\n    margin-bottom: 2px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .carbonation-bar, .body-bar{\n    display: flex;\n    align-items: center;\n    height: 15px;\n    width: 100%;\n    border: 1px rgb(133, 133, 133) solid;\n    border-radius: 5vw;\n  }\n  .beer-sweetness-col, .beer-body-col{\n    display: block;\n    width: 100%;\n  }\n  .body-label-columns{\n    display: flex; \n    width: 100%;\n    padding: 0 0 0 0px;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 30px;\n  }\n  .carbonation-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-flat-col{\n    width: 30%;\n  }\n  .r-lively-col{\n    width: 70%;\n    display: flex;\n    justify-content: end;\n  }\n  .flat-lable, .dry-label{\n    font-size: 12px;\n    color: black;\n    font-weight: 500;\n    margin: 0;\n    padding-top: 7px;\n    margin-left: 0%;\n    letter-spacing: .25px;\n  }\n  .lively-lable,.sweet-label{\n    font-size: 12px;\n    color: black;\n    font-weight: 500;\n    margin: 0;\n    padding-top: 7px;\n    padding-right: 2%;\n    letter-spacing: .25px;\n  }\n  .sweet-label{\n    text-align: right;\n    margin-left: 5px;\n  }\n\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .25px;\n    font-size: 24px;\n  }\n  .loading-spinner {\n    width: 70px;\n    height: auto;\n    border-radius: 0%;\n    animation: spin 3s linear infinite;\n    margin-bottom: 5px;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  .fade-in {\n    opacity: 1;\n    transition: opacity .7s ease-in;\n  }\n  \n  .invisible {\n    opacity: .8;\n  }\n  .loading-screen {\n    opacity: 1;\n    transition: opacity .2s ease-in;\n  }\n\n  .triangle-section{\n        padding: 2% 0% 7% 0%;\n        background-color: #fdf9f1;\n  }\n  .triangle-container{\n        width: 250px;\n        height: 163.5px;\n        position: relative;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding-top: 3px;\n        \n    }\n    .bitter-text{\n        font-size:  12px;\n        line-height: 20px;\n        font-weight: 500;\n        color: black;\n        text-align: center;\n        margin: -5px 0 1% 0 ;\n        letter-spacing: .25px;\n\n    }\n    .sweet-text{\n        font-size: 12px;\n        font-weight: 500;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: -3px;\n        left: 50px;\n        letter-spacing: .25px;\n    }\n    .dry-text{\n        font-size: 12px;\n        font-weight: 500;\n        color: black;\n        margin: 0;\n        position: absolute;\n        bottom: -3px;\n        right: 52px;\n        letter-spacing: .25px;\n    }\n    .triangle-img{\n        width: 93%;\n        left: 2.5%;\n        top: 10%;\n        height: auto;\n        margin: 0 0 0 0;\n        position: absolute;\n        z-index: 0;\n    } \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
